export default __webpack_public_path__ + "static/media/diners-club.c953e8c6.svg";